import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isProduction as isProductionHost, isStaging as isStagingHost, } from '#pplx/frontend/platform-components/env.js';
const STAGING_INDICATOR_DOT_STYLE = {
    backgroundColor: '#2CA0AB',
};
export function StagingEnvironmentIndicator({ isStagingServerEnvironment, }) {
    const clientHostname = typeof window === 'undefined' ? '' : window.location.hostname;
    const isProduction = isProductionHost(clientHostname);
    const isStaging = isStagingHost(clientHostname);
    // Hidden staging serves staging HTML from the production host, so the client
    // still reports production. Show the badge only in that split-brain case.
    if (!isStagingServerEnvironment || !isProduction || isStaging) {
        return null;
    }
    return (_jsxs("div", { "aria-hidden": "true", 
        // Keep this above the header glyphs, not over bottom-right composer actions.
        className: "pointer-events-none fixed left-[max(0.25rem,env(safe-area-inset-left))] top-[max(0.125rem,env(safe-area-inset-top))] z-[2147483647] inline-flex h-3.5 items-center gap-0.5 rounded-full border bg-raised px-1", children: [_jsx("span", { className: "size-1 rounded-full", style: STAGING_INDICATOR_DOT_STYLE }), _jsx("span", { className: "text-[10px] font-semibold leading-none text-primary", children: "STAGING" })] }));
}
//# sourceMappingURL=StagingEnvironmentIndicator.js.map